import React from 'react'
import moment from 'moment'
import 'moment/locale/es'
import API from './API'
import { strings } from './translations'

import { ReactComponent as HouseIcon } from '../../img/icons/house-types/house.fill.svg'
import { ReactComponent as CommunityIcon } from '../../img/icons/house-types/building.2.fill.svg'
import { ReactComponent as BusinessIcon } from '../../img/icons/house-types/storefront.fill.svg'
import { ReactComponent as TempleIcon } from '../../img/icons/house-types/building.columns.fill.svg'

const GUEST_UNLIMITED = 1;
const GUEST_TEMPORARY = 2;
const GUEST_RECURRENT = 3;

export const Utils =
{
    getInitials: (fullName) =>
	{
        const numInitials = 2;
        let initials = '';

        if (fullName != null &&
            fullName.length > 0)
        {
            let words = fullName.trim().split(' ');
            for (let i = 0; i < words.length && initials.length < numInitials; i++)
            {
                if (words[i].length > 0)
                    initials += words[i].charAt(0);
            }
        }

        return initials;
	},
	capitalize: (str) =>
	{
		return (str != null && str.length > 0) ? str.charAt(0).toUpperCase() + str.slice(1) : str;
	},
	isValidEmail: (str) =>
	{
		var re = /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;
		return re.test(str);
	},
    removeAccents(string)
    {
        const accents     = "ÀÁÂÃÄÅàáâãäåßÒÓÔÕÕÖØòóôõöøÈÉÊËèéêëðÇçÐÌÍÎÏìíîïÙÚÛÜùúûüÑñŠšŸÿýŽž";
        const accentsOut  = "AAAAAAaaaaaaBOOOOOOOooooooEEEEeeeeeCcDIIIIiiiiUUUUuuuuNnSsYyyZz";

        return string.split("")
                .map((letter, index) =>
                {
                    const accentIndex = accents.indexOf(letter);
                    return accentIndex !== -1 ? accentsOut[accentIndex] : letter;
                })
                .join("");
    },


    canTriggerDoorNow(roleType, permission)
    {
        var res = { canTrigger: false }

        if (roleType != null)
        {
            if (roleType == 'guest')
    		{
                if (permission != null)
                {
        			var permissionType = this.getGuestPermissionType(permission);

        			if (permissionType == GUEST_UNLIMITED)
        				res.canTrigger = true;
        			else if (permissionType == GUEST_TEMPORARY)
        			{
        				var now = moment();
        				var startMoment = moment(permission.startDate);
        				var endMoment = moment(permission.endDate);

        				res.canTrigger = (now.isSameOrAfter(startMoment) && now.isSameOrBefore(endMoment));

                        /*** TIMERS ***/
                        var startDateDiffSeconds = startMoment.diff(now, 'seconds');
        				var startDateIsInTheFuture = (startDateDiffSeconds > 0);

        				var endDateDiffSeconds = endMoment.diff(now, 'seconds');
        				var endDateIsInTheFuture = (endDateDiffSeconds > 0);

        				if (startDateIsInTheFuture)
        					res.startTimerSecs = startDateDiffSeconds+1;

        				if (endDateIsInTheFuture)
        					res.endTimerSecs = endDateDiffSeconds+1;
        			}
                    else if (permissionType == GUEST_RECURRENT)
        			{
                        var now = moment();
                        var startMoment = moment(permission.startDate);
                        var endMoment = (permission.endDate != null) ? moment(permission.endDate) : null;

                        var isInStartEndRange = (permission.endDate != null) ?
                            (now.isSameOrAfter(startMoment) && now.isSameOrBefore(endMoment)) :
                            now.isSameOrAfter(startMoment);

                        if (isInStartEndRange)
                        {
                            var dayOfWeek = now.day();
                            var todayPermissionDay = permission.permissionDays.filter(p =>
                            {
                                return p.dayOfWeek == dayOfWeek;
                            })[0];

                            if (todayPermissionDay != null)
                            {
                                if (todayPermissionDay.startTime == null && todayPermissionDay.endTime == null)
                                {
                                    res.canTrigger = true;

                                    if (endMoment != null)
                                    {
                                        var endDateDiffSeconds = endMoment.diff(now, 'seconds');
                        				var endDateIsInTheFuture = (endDateDiffSeconds > 0);

                                        if (endDateIsInTheFuture)
                        					res.endTimerSecs = endDateDiffSeconds+1;
                                    }
                                }
                                else
                                {
                                    var nowTime = moment().hour()*60 + moment().minute();
                                    res.canTrigger = (nowTime >= todayPermissionDay.startTime && nowTime < todayPermissionDay.endTime);

                                    if (todayPermissionDay.startTime > nowTime)
                                    {
                                        var startTimeMoment = moment().hours(parseInt(todayPermissionDay.startTime/60)).minutes(parseInt(todayPermissionDay.startTime%60)).seconds(0);
                                        res.startTimerSecs = startTimeMoment.diff(moment(), 'seconds');
                                    }

                                    if (todayPermissionDay.endTime > nowTime)
                                    {
                                        var endTimeMoment = moment().hours(parseInt(todayPermissionDay.endTime/60)).minutes(parseInt(todayPermissionDay.endTime%60)).seconds(0);
                                        res.endTimerSecs = endTimeMoment.diff(moment(), 'seconds');
                                    }
                                }
                            }
                            else
                            {
                                if (permission.endDate != null)
                                {
                                    var endDateDiffSeconds = endMoment.diff(now, 'seconds');
                    				var endDateIsInTheFuture = (endDateDiffSeconds > 0);

                                    if (endDateIsInTheFuture)
                    					res.endTimerSecs = endDateDiffSeconds+1;
                                }
                            }
                        }

                        if (!isInStartEndRange)
                        {
                            var startDateDiffSeconds = startMoment.diff(now, 'seconds');
            				var startDateIsInTheFuture = (startDateDiffSeconds > 0);

                            if (startDateIsInTheFuture)
            					res.startTimerSecs = startDateDiffSeconds+1;
                        }
                    }
                }
            }
    		else
    			res.canTrigger = true;
        }

        return res;
    },
    getGuestPermissionType(permission)
    {
        var permissionType = null;

        if (permission != null)
        {
    		if ((permission.permissionDays == null || permission.permissionDays.length == 0) && permission.startDate == null && permission.endDate == null)
    			permissionType = GUEST_UNLIMITED;
    		else if ((permission.permissionDays == null || permission.permissionDays.length == 0) && permission.startDate != null && permission.endDate != null)
    			permissionType = GUEST_TEMPORARY;
            else if ((permission.permissionDays !== null || permission.permissionDays.length !== 0) && permission.startDate != null)
    			permissionType = GUEST_RECURRENT;
        }

		return permissionType;
    },
    
    
    getUrlParams(query)
	{
	    return query
	        ? (/^[?#]/.test(query) ? query.slice(1) : query)
	            .split('&')
	            .reduce((params, param) => {
	                    let [key, value] = param.split('=');
	                    params[key] = value ? decodeURIComponent(value.replace(/\+/g, ' ')) : '';
	                    return params;
	                }, {}
	            )
	        : {}
	},
    
    
    mergeActionsAndSensors(activitySections, newEventsAndActions, formatForCSV)
    {
        let newActivitySections = [...activitySections]
            
        const getSectionTitle = (date) =>
    	{
    		let todayMoment = moment().local()
    		let dateMoment = moment(date).local()
    		let sectionTitle = dateMoment.locale('es').format('DD/MM/YYYY')
    		
    		if (dateMoment.isSame(todayMoment, 'day'))
    		{
    			sectionTitle = strings('today')
    		}
    		else if (dateMoment.isSame(todayMoment.subtract(1, 'day'), 'day'))
    		{
    			sectionTitle = strings('yesterday')
    		}
    		else if (dateMoment.isSame(todayMoment, 'week'))
    		{
    			sectionTitle = dateMoment.locale('es').format('dddd')
    		}
    		else if (dateMoment.isSame(todayMoment, 'year'))
    		{
    			sectionTitle = dateMoment.locale('es').format('ddd DD MMMM')
    		}
    		else
    		{
    			sectionTitle = dateMoment.locale('es').format('ddd DD MMMM, YYYY')
    		}
    		
    		return sectionTitle
    	}

        if (newEventsAndActions.actions != null)
        {
            newEventsAndActions.actions.forEach((item) =>
            {
                let sectionTitle = getSectionTitle(item.date)
    			let foundSection = newActivitySections.find(section => section.title === sectionTitle)

    			if (foundSection == null)
    			{
    				foundSection = { activity: [], title: sectionTitle }
    				newActivitySections.push(foundSection)
    			}
    			
                let activityItem =
                {
                    type: item.actionType,
                    subType: item.actionSubType,
                    date: moment(item.date),
                    name: `${item.user.name} ${item.user.lastName}`
                }
                if (item.isLiveEvent)
                    activityItem.isLiveEvent = item.isLiveEvent
                    
    			foundSection.activity.push(activityItem)
            })
        }

        if (newEventsAndActions.sensor != null)
        {
            newEventsAndActions.sensor.forEach((item) =>
            {
                // Avoid duplicates
                //if (activitySections.some(it => it.date.toISOString() === item.date))
                    //return
                
                let sectionTitle = getSectionTitle(item.date)
    			let foundSection = newActivitySections.find(section => section.title === sectionTitle)

    			if (foundSection == null)
    			{
    				foundSection = { activity: [], title: sectionTitle }
    				newActivitySections.push(foundSection)
    			}
                
                let activityItem =
                {
                    type: item.eventType,
                    date: moment(item.date)
                }
                if (item.isLiveEvent)
                    activityItem.isLiveEvent = item.isLiveEvent
    			
    			foundSection.activity.push(activityItem)
            })
        }
        
        if (newEventsAndActions.recordings != null)
        {
            newEventsAndActions.recordings.forEach((item) =>
            {
                let sectionTitle = getSectionTitle(item.endDate)
    			let foundSection = newActivitySections.find(section => section.title === sectionTitle)

    			if (foundSection == null)
    			{
    				foundSection = { activity: [], title: sectionTitle }
    				newActivitySections.push(foundSection)
    			}
    			
                let activityItem =
                {
                    type: "CAMERA_RECORDING",
                    date: moment(item.endDate),
                    thumbnailUrl: item.thumbnailUrl,
                    name: (item.userInfo != null) ? `${item.userInfo.name} ${item.userInfo.lastName}` : null
                }
                if (item.isLiveEvent)
                    activityItem.isLiveEvent = item.isLiveEvent
                
    			foundSection.activity.push(activityItem)
            })
        }

        newActivitySections.forEach((section) =>
        {
            section.activity.sort(function(a,b)
            {
                return b.date - a.date
            })
        })
        
        newActivitySections.sort((sectionA, sectionB) =>
		{
			return (new Date(sectionA.activity[0].date)) >= (new Date(sectionB.activity[0].date)) ? -1 : 1
		})
        
        
        if (formatForCSV)
        {
            let CSVArray = []
            
            newActivitySections.forEach((section) =>
            {
                section.activity.forEach((item) =>
                {
                    item.date = item.date.format('DD/MM/YYYY HH:mm:ss')
                    
                    if (item.type === 'CIRCUIT_OPENED')
                        item.type = strings('csvOpenDoor')
                    else if (item.type === 'CIRCUIT_CLOSED')
                        item.type = strings('csvClosedDoor')
                    else if (item.type === 'TRIGGER_DOOR')
                        item.type = strings('csvTriggerDoor')
                    else if (item.type === 'CAMERA_RECORDING')
                        item.type = strings('csvCamera')
                    
                    CSVArray.push(item)
                })
            })
            
            newActivitySections = CSVArray
        }
        
    
        return newActivitySections
    },
    
    
    getVRisExpired: (vr) =>
    {
        if (vr == null) return {}
        
        // vr.expireDate = moment().add(-2, 'days').toISOString()
        // vr.virtualRemote.expired = true
        // if (vr.subscription == null)
        //     vr.subscription = { status: 'cancelled' }
        // else
        //     vr.subscription.status = 'cancelled'
        
        let isCancelled = vr?.subscription?.status === 'cancelled'
        let isTrial     = vr?.subscription?.status === 'trial'
        let isPastDue   = vr?.subscription?.status === 'past_due'
        
        let now = moment()
		let daysTilExpiration = moment(vr?.expireDate).diff(now, 'days')
		let hoursTilExpiration = moment(vr?.expireDate).diff(now, 'hours')
        let minutesTilExpiration = moment(vr?.expireDate).diff(now, 'minutes')
        let isExpired = moment(now).isAfter(vr?.expireDate)
        
        let is5years = vr?.subscription?.type === '5 years'
        
        let userPays = vr?.delegatedUserId === API.getInstance().getUserId()
        let paymentAdded = vr?.subscription?.paymentAdded
        let paymentSuspended = vr?.subscription?.paymentSuspended
        
        let expiredObj =
        {
            isExpired,
            daysTilExpiration,
            hoursTilExpiration,
            minutesTilExpiration,
            isCancelled,
            isTrial,
            is5years,
            userPays,
            paymentAdded,
            paymentSuspended,
            isPastDue
        }
        //console.log(vr, expiredObj)
        
        return expiredObj
    },
    getSubscriptionsFromVirtualRemotes: (virtualRemotes) =>
    {
        let subscriptions = []
        
        virtualRemotes.forEach(vr =>
        {
            if (vr.virtualRemote.type === 'permanent')
            {
                let freeRemotes = subscriptions.find(s => s.id === 'permanent')
                if (freeRemotes == null)
                    subscriptions.push({ id: 'permanent', type: 'permanent', virtualRemotes: [vr] })
                else
                    freeRemotes.virtualRemotes.push(vr)
            }
            else if (vr.virtualRemote.type === 'subscription' && vr.subscription != null)
            {
                let modifiedVR = {...vr}
                //delete modifiedVR.subscription
                
                let sub = subscriptions.find(s => s.id === vr.subscription.id)
                if (sub == null)
                    subscriptions.push({ ...vr.subscription, virtualRemotes: [modifiedVR] })
                else
                    sub.virtualRemotes.push(modifiedVR)
            }
        })
        
        return subscriptions
    },
    
    
    getHouseTypeIcon: (house) =>
    {
        let icon = <HouseIcon />
        
        switch (house.type)
        {
            case 'community':   icon = <CommunityIcon />;  break
            case 'business':    icon = <BusinessIcon />;   break
            case 'other':       icon = <TempleIcon />;     break
        }
        
        return icon
    }
}
